<div class="account-operation-trigger d-flex justify-content-start align-items-start mb-3">
  <div class="account-operation-trigger__col px-4 d-flex justify-content-start align-items-center">
    <label class="account-operation-trigger__label text-nowrap me-2">
      Trigger Type:
    </label>
    <select aria-label="Trigger Type" class="form-select w-auto" [formControl]="form.controls.triggerType"
      data-cy="TriggerTypeSelect">
      @for (tuple of triggerTypes; track tuple) {
        <option [ngValue]="tuple[0]">{{tuple[1]}}</option>
      }
    </select>
  </div>
  @switch (form.controls.triggerType.value) {
    <!-- Template Association -->
    @case (0) {
      <div class="account-operation-trigger__col px-4 border-start">
        <div class="pb-2">
          <em class="d-block my-2 ps-4 ms-3 text-nowrap">
            When a {{ anchorTemplate?.templateName }} or its Parent Installment record is associated to the
            following Accounting
            Template:
          </em>
        </div>
        <div class="pb-2 d-flex justify-content-start align-items-center">
          <label class="account-operation-trigger__label text-nowrap text-end me-2">
            Template:
          </label>
          <select aria-label="Template" class="form-select w-auto" [formControl]="form.controls.templateId"
            data-cy="TemplateSelect">
            @for (t of accountingTemplates; track t) {
              <option [ngValue]="t.templateID">{{ t.templateName }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    <!-- Workflow Action -->
    @case (1) {
      <div class="account-operation-trigger__col px-4 border-start">
        <div class="pb-2 d-flex justify-content-start align-items-center">
          <label class="account-operation-trigger__label text-nowrap text-end me-2">
            Action:
          </label>
          <select aria-label="Action" class="form-select me-2 w-auto" [formControl]="form.controls.actionId"
            data-cy="WorkflowActionSelect">
            @for (action of availableWorkflowActions; track action) {
              <option [ngValue]="action.actionId">
                {{ action.actionName }}
              </option>
            }
          </select>
          <em class="text-nowrap">taken on a {{ anchorTemplate?.templateName }} or its Parent Installment
          record.</em>
        </div>
        <div class="pb-2 d-flex justify-content-start align-items-center">
          <label class="account-operation-trigger__label text-nowrap text-end me-2">Resulting
          Status:</label>
          <span class="ps-2 text-nowrap">{{ resultingStatus }}</span>
        </div>
      </div>
    }
    <!-- Data Behavior-->
    @case (2) {
      <div class="account-operation-trigger__col px-4 border-start">
        @if (parentTableTemplateOptions?.length > 0) {
          <div
            class="pb-2 d-flex justify-content-start align-items-start">
            <label class="account-operation-trigger__label text-nowrap text-end me-1 p-1">
              Template:
            </label>
            <select aria-label="Template" class="form-select me-2 w-auto" [formControl]="templateOptionControl"
              data-cy="TemplateOptionControlSelect">
              <optgroup label="Revenue Allocation Template">
                @for (opt of anchorTemplateOptions; track opt) {
                  <option [ngValue]="opt">
                    {{ opt.template.templateName }}
                  </option>
                }
              </optgroup>
              @if (parentTableTemplateOptions.length > 0) {
                <optgroup label="Parent Table Template">
                  @for (opt of parentTableTemplateOptions; track opt) {
                    <option [ngValue]="opt">
                      {{ opt.template.templateName }}
                    </option>
                  }
                </optgroup>
              }
            </select>
          </div>
        }
        <div class="pb-2 d-flex justify-content-start align-items-start">
          <label class="account-operation-trigger__label text-nowrap text-end me-1 p-1">
            Field:
          </label>
          <select aria-label="Field" class="form-select me-2 w-auto"
            [formControl]="form.controls.characteristicId" data-cy="FieldSelect">
            @for (cmd of templateCmds; track cmd) {
              <option [ngValue]="cmd.characteristicID">
                {{ cmd.label }}
              </option>
            }
          </select>
          <select aria-label="Operator" class="form-select me-2 w-auto" [formControl]="form.controls.operator"
            data-cy="OperatorsSelect">
            @for (op of availableOperators; track op) {
              <option [ngValue]="op.operator">
                {{ op.label }}
              </option>
            }
          </select>
          <rl-data-behavior-value-entry [valueEntryType]="valueEntryType" [cmd]="selectedDataBehaviorCmd"
            [form]="form">
          </rl-data-behavior-value-entry>
        </div>
      </div>
    }
    <!-- Record Creation -->
    @case (3) {
      <div class="account-operation-trigger__col px-4 border-start">
        <div>
          <em class="d-block my-2 ps-4 ms-3 text-nowrap">
            When a
            <select aria-label="Amount Template" class="form-select w-auto d-inline"
              [formControl]="form.controls.amountTemplateId" data-cy="WhenTemplateSelect">
              @for (t of amountTemplates; track t) {
                <option [ngValue]="t.templateID">{{ t.templateName }}
                </option>
              }
            </select>
            is created on a
            <select aria-label="Table Template" class="form-select w-auto d-inline"
              [formControl]="form.controls.tableTemplateId" data-cy="CreatedOnTemplateSelect">
              @for (t of tableTemplates; track t) {
                <option [ngValue]="t.templateID">{{ t.templateName }}
                </option>
              }
            </select>
          </em>
        </div>
        <div class="pb-2">
          <em class="d-block my-2 ps-4 ms-3 text-nowrap text-muted">
            Where the same Catalog association exists on the above record creation and existing Anchor
            Template records
          </em>
        </div>
      </div>
    }
  }
</div>
<div class="align-items-center justify-content-end d-flex mt-4">
  @if (form.hasError('duplicateTriggers')) {
    <span class="text-danger text-nowrap me-4">
      Duplicate triggers are not allowed
    </span>
  }
  @if (form.hasError('duplicateWorkflow')) {
    <span class="text-danger text-nowrap me-4">
      Only one trigger can be of type Workflow Action
    </span>
  }
  <button class="btn btn-light btn-sm me-2" (click)="cancel()" data-cy="CancelForm">
    Cancel
  </button>
  <button class="btn btn-info btn-sm" (click)="save()" [disabled]="!form.valid" data-cy="SubmitForm">
    Save
  </button>
</div>